/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoutineListResponse } from '../models/RoutineListResponse';
import type { RoutineTriggerResponse } from '../models/RoutineTriggerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoutinesService {
  /**
   * List routines
   * List every routine the authenticated user can see and trigger.
   *
   * Per functional spec § "List routines", filters HA entities to those
   * in the ``automation`` domain and renders each as a :class:`Routine`
   * with plain-language ``trigger_summary`` / ``action_summary``.
   *
   * No caching at MVP — the routine list is small (typically <50
   * entries) and rarely fetched (post-load in the UI's Routines view).
   * @returns RoutineListResponse Successful Response
   * @throws ApiError
   */
  public static listRoutinesRoutinesGet(): CancelablePromise<RoutineListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/routines',
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        429: `Too Many Requests`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * Trigger a routine
   * Manually fire the given routine via ``automation.trigger``.
   *
   * Per functional spec § "Trigger a routine", returns ``202 Accepted``
   * on success; the actual execution result surfaces asynchronously as
   * a WebSocket ``routine_executed`` frame. Failure mapping:
   *
   * * 503 :class:`UnavailableError` — HA Core is down or unreachable.
   * * 404 ``routine_not_found`` — HA rejected the call with an
   * identifiable "not found" 4xx.
   * * 502 :class:`BadGatewayError` — HA returned a 5xx (the original
   * error is preserved in ``ha_error``).
   * @returns RoutineTriggerResponse Successful Response
   * @throws ApiError
   */
  public static triggerRoutineRoutinesRoutineIdTriggerPost({
    routineId,
  }: {
    routineId: string,
  }): CancelablePromise<RoutineTriggerResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/routines/{routine_id}/trigger',
      path: {
        'routine_id': routineId,
      },
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Validation Error`,
        429: `Too Many Requests`,
        502: `Bad Gateway`,
        503: `Service Unavailable`,
      },
    });
  }
}
